import styled from 'styled-components';
import { ToastContainer as Toaster } from 'react-toastify';

export const ToastWrapper = styled.div`
  .Toastify__toast-container {
    top: 30px !important;

    @media ${(props) => props.theme.device.tabletL} {
      top: 20px !important;
    }

    @media ${(props) => props.theme.device.mobileL} {
      top: 0px !important;
    }
  }
`;

export const ToastContainer = styled(Toaster)`
  /* Common  */
  .Toastify__toast-icon {
    display: none;
  }
  .Toastify__toast--default {
    background-color: ${({ theme }) => theme.colors.sharkLight};
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.8);
    color: ${({ theme }) => theme.colors.white};
  }

  /* Info style  */
  .Toastify__toast--info {
    .icon-info-circle {
      fill: none;
      stroke: #757575;
    }
    button {
      opacity: 0.6;
      &:hover {
        opacity: 1;
      }
      svg {
        fill: #6bb1e4;
      }
    }
  }

  /* Success style  */
  .Toastify__toast--success {
    background-color: ${({ theme }) => theme.colors.success};
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.8);
    color: ${({ theme }) => theme.colors.white};
    button {
      opacity: 0.6;
      &:hover {
        opacity: 1;
      }
      svg {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
  .Toastify__progress-bar--success {
    background-color: ${({ theme }) => theme.colors.greyLight};
  }

  /* Error style  */
  .Toastify__toast--error {
    background-color: ${({ theme }) => theme.colors.fail};
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.8);
    color: ${({ theme }) => theme.colors.white};
    button {
      opacity: 0.6;
      &:hover {
        opacity: 1;
      }
      svg {
        fill: ${({ theme }) => theme.colors.white};
      }
    }
  }
  .Toastify__progress-bar--error {
    background-color: ${({ theme }) => theme.colors.greyLight};
  }
`;

export const ToastCustomContainer = styled.div`
  padding: 7px 5px;
  display: flex;
  align-items: center;
  flex-direction: row;
  flex-wrap: nowrap;
  width: 100%;
  gap: 20px;

  svg {
    fill: none;
    stroke: ${({ theme }) => theme.colors.white};
  }
`;
